import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { CustomEvents, ENABLE_FO_LINK, MAP_ACCOUNT_LINK } from '@app/_helpers';
import { ConfigurationService, EventsService, PortfolioService } from '@app/_shared/providers';
import { CUSTOM_TOASTR_TYPE } from '@app/_shared/shared.enums';
import { RouteMap } from '@app/_shared/shared.structs';
import { PLANS_DIALOG_TITLE } from '@app/_shared/strings';
import { ToastrService } from 'ngx-toastr';
import { CustomToasterConfig } from './custom-toaster.interface';
import { MbPlansComponent } from '@app/modules/trading/modules/mb-plans/mb-plans.component';

@Component({
  selector: 'app-custom-toaster',
  templateUrl: './custom-toaster.component.html',
  styleUrls: ['./custom-toaster.component.scss']
})



export class CustomToasterComponent implements OnInit {
  @Input('toastData') toastData: CustomToasterConfig;
  toastrTypes = CUSTOM_TOASTR_TYPE;


  constructor(
    private router: Router,
    private toastService: ToastrService,
    private eventService: EventsService,
    private dialog: MatDialog,
    private portfolioService: PortfolioService,
    private configService: ConfigurationService
  ) { }

  ngOnInit(): void {}
  navigateToDetails() {
    if (this.toastData.button) {
      if (this.toastData.button.link === RouteMap.deployedSection) {
        this.eventService.publish(CustomEvents.DeployedTab);
      }
      // TODO: Find where these toasts are triggered from!!
      // if (this.toastData.button.link === RouteMap.plans && !this.configService.remoteConfigCacheObj?.PLANS_CONFIG?.disablePlans) {
      //   this.openPricingDialog();
      // } else 
      if (this.toastData.button.link === ENABLE_FO_LINK || this.toastData.button.link === MAP_ACCOUNT_LINK || this.toastData.button.link === this.configService.remoteConfigCacheObj?.BROKER_NOT_AVAILABLE_HELP_LINK) {
        window.open(this.toastData.button.link, "_blank");
      } else if (this.toastData.portfolioId && this.toastData.uniquePortfolioID) {
        this.portfolioService.openAnalytics(this.toastData.portfolioId, this.toastData.button.link, this.toastData.uniquePortfolioID);
      } else if (this.toastData.portfolioId) {
        this.portfolioService.openAnalytics(this.toastData.portfolioId, this.toastData.button.link);
      } else {
          this.router.navigateByUrl(this.toastData.button.link);
      }
    }
    this.closeIcon();
  }

  closeIcon() {
    this.toastService.remove(this.toastData.toastId);
  }

  openPricingDialog() {
    this.dialog.open(MbPlansComponent, {
      panelClass: ['dialog-no-padding-rounded'],
      data: {
        title: PLANS_DIALOG_TITLE
      },
      width: '90%'
    })
  }

  getToastClass(): string {
    if (this.toastData.toastrType === this.toastrTypes.simpleToastr) {
      return 'text-new-green';
    } else if (this.toastData.toastrType === this.toastrTypes.detailedToastr) {
      return 'toast-yellow';
    } else if (this.toastData.toastrType === this.toastrTypes.clickableToastr) {
      return 'text-negative-toast';
    }
    return ''; // Default case if none of the conditions match
  }
}
